/**
 * transforms a url to the current language url
 *
 * @param {String} url - parth url starting without language prefix
 */
 export const multilingual_url = (url) => {
  const currentUrlPrefix = window.multilingual_settings.translationUrlPrefixes[i18next.language];

  if(currentUrlPrefix === '/') {
    return url;
  }
  else {
    return `${currentUrlPrefix}${url}`;
  }
}
